import { Injectable } from '@angular/core'

import { Observable } from 'rxjs/Observable'
import 'rxjs/add/operator/do'

import { Store } from '@ngrx/store'
import { AppState } from '../reducers'

import { User } from '../models'
import { UserApi } from '../apis'
import { SetCurrentUser } from '../actions/user'

@Injectable()
export class UserService {
  constructor(
    private store: Store<AppState>,
    private api: UserApi,
  ) {}

  getCurrentUser(): Observable<User> {
    return this.api.profile()
                   .do((u) => this.store.dispatch(new SetCurrentUser(u)))
  }
}



// WEBPACK FOOTER //
// ./src/services/user.ts